import Vue from 'vue'
import Router from 'vue-router'
//import communicationDetails from '@/views/communication/communicationDetails.vue'
//import communicationInteraction from '@/views/communication/communicationInteraction.vue'
Vue.use(Router)

export const constantRoutes = [{
		path: '/',
		name: '/',
		component: () =>
			import('@/views/index'),
	},
	{
		path: '/index',
		name: 'index',
		component: () =>
			import('@/views/index'),
	},
	{
		path: '/search',
		name: 'search',
		component: () =>
			import('@/views/index/search'),
	},
	{
		path: '/news',
		name: 'news',
		component: () =>
			import('@/views/news/centerOverview'),
	},
	{
		path: '/newsdetail',
		name: 'newsdetail',
		component: () =>
			import('@/views/news/detail'),
	},
	{
		path: '/courses',
		name: 'courses',
		component: () =>
			import('@/views/courses/list'),
	},
	{
		path: '/courseindex',
		name: 'courseindex',
		component: () =>
			import('@/views/courses/index'),
	},
	{
		path: '/courseindexpublic',
		name: 'courseindexpublic',
		component: () =>
			import('@/views/courses/indexpublic'),
	},
	{
		path: '/coursedetail',
		name: 'coursedetail',
		component: () =>
			import('@/views/courses/detail'),
	},
	{
		path: '/coursedetailpublic',
		name: 'coursedetailpublic',
		component: () =>
			import('@/views/courses/detailpublic'),
	},
	{
		path: '/livelist',
		name: 'livelist',
		component: () =>
			import('@/views/live/liveBroadcast'),
	},
	{
		path: '/live',
		name: 'live',
		component: () =>
			import('@/views/live/index'),
	},
	{
		path: '/indexover',
		name: 'indexover',
		component: () =>
			import('@/views/live/indexover'),
	},
	{
		path: '/communication',
		name: 'communication',
		component: () =>
			import('@/views/communication/communicationInteraction'),
	},
	{
		path: '/communicationDetails',
		name: 'communicationDetails',
		component: () =>
			import('@/views/communication/communicationDetails'),
	},
	{
		path: '/center',
		name: 'center',
		component: () =>
			import('@/views/center/center'),
	},

	{
		path: '/examinelist',
		name: 'examinelist',
		component: () =>
			import('@/views/examine/list'),
	},
	{
		path: '/examine',
		name: 'examine',
		component: () =>
			import('@/views/examine/index'),
	},
	{
		path: '/examdetails',
		name: 'examdetails',
		component: () =>
			import('@/views/examine/details'),
	},
	{
		path: '/tasklist',
		name: 'tasklist',
		component: () =>
			import('@/views/task/list'),
	},
	{
		path: '/task',
		name: 'task',
		component: () =>
			import('@/views/task/index'),
	},
	{
		path: '/taskdetails',
		name: 'taskdetails',
		component: () =>
			import('@/views/task/details'),
	},
	{
		path: '/test',
		name: 'test',
		component: () =>
			import('@/views/test/index'),
	},
	{
		path: '/testdetails',
		name: 'testdetails',
		component: () =>
			import('@/views/test/details'),
	},
	{
		path: '/plot',
		name: 'plot',
		component: () =>
			import('@/views/plot/index'),
	},
	{
		path: '/plotinfo',
		name: 'plotinfo',
		component: () =>
			import('@/views/plot/detail'),
	},
	{
		path: '/redirect',
		name: 'redirect',
		component: () =>
			import('@/components/redirect'),
		meta: {
			hidenav: 'hidenav'
		},
	},
]

const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router